import axios from 'axios';
import jwtDecode from 'jwt-decode';
import dayjs from 'dayjs';
import { getSubdomainClub } from '../shared/components/Club';

export interface JWTDecoded {
  sub: number;
  iss: string;
  iat: number;
  exp: number;
  nbf: number;
  jti: string;
}

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_API,
  headers: {
    'x-transaction-origin': 'cloud-system-client',
  },
});

export const accessTokenKey = 'SN-access-token-client';

const logout = () => {
  delete axios.defaults.headers.common['Authorization'];
  localStorage.removeItem('persist:cloud-system');
  localStorage.removeItem(accessTokenKey);
  window.location.reload();
};

instance.defaults.headers.common['Access'] = 'application/json';
instance.defaults.headers.common['Content-Type'] = 'application/json';
instance.interceptors.request.use(async req => {
  if (req.headers) {
    req.headers['x-transaction-subdomain'] = getSubdomainClub();
  }
  const bearerToken = localStorage.getItem(accessTokenKey);
  if (req.headers && bearerToken) {
    const tokenDecoded: JWTDecoded = jwtDecode(bearerToken);
    const isExpired = dayjs.unix(tokenDecoded.exp).diff(dayjs()) < 1;
    if (!isExpired) return req;
    logout();
  }

  return req;
});

instance.interceptors.response.use(
  res => {
    return res;
  },
  error => {
    if (error.response.status === 401) {
      logout();
    }
    return Promise.reject(error);
  },
);

if (localStorage.getItem(accessTokenKey)) {
  instance.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem(
    accessTokenKey,
  )}`;
}

export default instance;
